const onBackspaceOrDel =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      handler(e, ...args);
    }
  };

export default onBackspaceOrDel;
